import { Button, Modal } from 'react-dsgov';
import { DiefCfemContext } from '../../../../../../../../../../../contexts/DiefCfemContext';
import { useNotificacao } from '../../../../../../../../../../../hooks/useNotificacao';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import { IReceitaExportacoes } from '../../../../../../../../../../../interfaces/IReceitaExportacoes';
import { useBackEndRequests } from '../../../../../../../../../lib/backEndRequests';
import style from './listaReceitaExportacoes.module.scss';
import React, { useContext, useState } from 'react';
import { BrButton } from '@govbr-ds/react-components';
import ListaReceitaExportacoesItem from './listaReceitaExportacoesItem/listaReceitaExportacoesItem';
import CustomConfirmer from '../../../../../../../../../../../components/customConfirmer/customConfirmer';

interface IListaReceitaExportacoesProps {
  receitaExportacoes: IReceitaExportacoes | undefined;
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  refetchLista: () => void;
  refetchDados: () => void;
}

const ListaReceitaExportacoes = ({
  receitaExportacoes,
  setBaseDeCalculo,
  setIsEdicao,
  refetchLista,
  refetchDados,
}: IListaReceitaExportacoesProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const context = useContext(DiefCfemContext);

  const { deleteReceitaExportacoes } = useBackEndRequests();
  const mostrarNotificacao = useNotificacao();

  const editarReceitaExportacoes = () => {
    context?.setIdReceitaExportacoes(receitaExportacoes?.id ?? -1);
    setIsEdicao(true);
    setBaseDeCalculo('receitaExportacoes');
  };

  const deletarReceitaExportacoes = async () => {
    await deleteReceitaExportacoes(receitaExportacoes?.id ?? -1)
      .then(() => {
        refetchLista();
        refetchDados();
        setIsModalOpened(false);
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao deletar Receita Bruta Exportações, tente novamente.',
          ...(err && { complementoSentryId: err }),
        });
      });
  };

  return (
    <>
      <Modal title='Excluir Receita Exportações Selecionada' useScrim modalOpened={isModalOpened}>
        <Modal.Body>Deseja mesmo deletar a receita de exportações selecionada?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deletarReceitaExportacoes()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>Receita Calculada (-) Exportações</div>
        </div>
        <div className={style.rightContainer}>
          <BrButton
            data-testid='edit-button'
            circle
            size='small'
            icon='fas fa-edit fa-sm'
            onClick={() => editarReceitaExportacoes()}
          />
          <BrButton
            data-testid='delete-button'
            circle
            size='small'
            icon='fas fa-trash fa-sm'
            onClick={() => setIsModalOpened(true)}
          />
        </div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          {receitaExportacoes?.exportacoes && receitaExportacoes?.exportacoes.length > 0 && (
            <ListaReceitaExportacoesItem receitaExportacoes={receitaExportacoes.exportacoes} isVinculada={false} />
          )}
          {receitaExportacoes?.exportacoesVinculada && receitaExportacoes?.exportacoesVinculada.length > 0 && (
            <ListaReceitaExportacoesItem
              receitaExportacoes={receitaExportacoes.exportacoesVinculada}
              isVinculada={true}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ListaReceitaExportacoes;
